import { createFileRoute } from '@tanstack/react-router';

import { createMigrationRouteGuard } from '@/utils/route-guards/migration-guard';

export const Route = createFileRoute('/$org/$agent/process-view')({
  beforeLoad: (ctx) => {
    createMigrationRouteGuard('process-view')(ctx);
  },
});
